export default __webpack_public_path__ + "static/media/matchingColors1Sample.95c70e9f2dad9678911333cea65086be.png";